export const ExternalLabelInput = (props: {
  label?: string;
  value: string | number | null | undefined;
  placeholder?: string;
  type?: string;
  onKeyDown?: (e: { currentTarget: { value: string }; key: string }) => void;
  onChange?: (e: { target: { value: string } }) => void;
  onInput?: (e: { target: { value: string } }) => void;
  disabled?: boolean;
  error?: string | string[] | null | boolean;
  ref?: (el: HTMLInputElement) => void;
}) => {
  const hasError = () =>
    props.error !== false &&
    props.error != null &&
    (Array.isArray(props.error) ? props.error.length > 0 : props.error !== '');

  return (
    <div class="relative">
      <div class="text-sm text-gray-500 font-medium">{props.label}</div>
      <input
        class={`w-full px-3 py-2 border rounded-md shadow-xs focus:outline-hidden
          disabled:bg-gray-100 disabled:border-gray-300 disabled:text-gray-500
          border-input-border focus:border-armstrong-primary hover:border-armstrong-primary
          ${hasError() ? 'border-error-red focus:border-error-red hover:border-error-red' : ''}`}
        value={props.value ?? ''}
        type={props.type ?? 'text'}
        onChange={props.onChange}
        onInput={props.onInput}
        onKeyDown={props.onKeyDown}
        onWheel={
          (props.type ?? 'text') === 'number'
            ? (e) => e.preventDefault()
            : undefined
        }
        placeholder={props.placeholder ?? ''}
        ref={props.ref}
        disabled={props.disabled}
      />
      {props.error && (
        <div class="text-error-red text-xs mt-1 px-2">{props.error}</div>
      )}
    </div>
  );
};
